module.exports = __webpack_public_path__ + "static/logo-normstahl-1593e0abdae908fd34645a5a2026e180.jpg";